<template>
  <span
    class="inline-flex items-center justify-center w-6 h-6
      transition rounded-full bg-secondary-15 hover:bg-secondary-20 private-mode-button"
  >
    <aha-icon
      class="text-secondary-50 private-mode-icon"
      v-if="presentation.privateMode"
      :name="privateIconName"
      :viewBox="privateIconViewBox"
      :width="privateIconSize"
      :height="privateIconSize"
      v-tooltip="$i18nPresenter.t('Private: Audience cannot see or interact with your slides')"
    />

    <aha-icon
      class="text-secondary-50 private-mode-icon"
      v-else
      :name="publicIconName"
      :viewBox="publicIconViewBox"
      :width="publicIconSize"
      :height="publicIconSize"
      v-tooltip="$i18nPresenter.t('Public: Audience can see and interact with your slides')"
    />
  </span>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PrivateModeButton',
  props: {
    presentation: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters('featureToggles', ['canUseNewCleanUpEditorUI']),
    privateIconName() {
      return this.canUseNewCleanUpEditorUI ? 'Lock-v2' : 'lockv2'
    },
    privateIconSize() {
      return this.canUseNewCleanUpEditorUI ? '16' : '18'
    },
    privateIconViewBox() {
      return this.canUseNewCleanUpEditorUI ? '0 0 16 16' : '0 0 14 20'
    },
    publicIconViewBox() {
      return this.canUseNewCleanUpEditorUI ? '0 0 16 16' : '0 0 20 20'
    },
    publicIconSize() {
      return this.canUseNewCleanUpEditorUI ? '16' : '18'
    },
    publicIconName() {
      return this.canUseNewCleanUpEditorUI ? 'globe' : 'icon-multiple-language'
    },
  },
}
</script>
